import React, { FunctionComponent } from 'react'
import styles from './TaskTabs.module.sass'
import { Task, taskStatusToColor } from '../../../responses/tasks'
import TenderPicker from '../../data-components/pickers/TenderPicker/TenderPicker'
import { TaskStatus } from '../../../constants/enums'
import { PERMISSIONS } from '../../../constants/permissions'
import { taskActions } from '../../../redux/data/task/task-actions'
import { Classes } from '../../../styles'
import DeadlinePanel from '../../data-components/elements/DeadlinePanel/DeadlinePanel'
import { useAllPermissions, useRootDispatch } from '../../../utils/hooks'
import { useQueries } from '../../../utils/hooks/useQueries'
import ColoredTab from '../ColoredTabs/ColoredTab'

interface Props {
    className?: string,
    task: Task,
    active?: boolean,
    minimal?: boolean,
    onClick?: () => void,
}

const TaskTab: FunctionComponent<Props> = props => {
    const dispatch = useRootDispatch()

    const {isMobile} = useQueries()
    const canEdit = useAllPermissions([PERMISSIONS.TASK.EDIT])

    return <ColoredTab
        className={props.className}
        color={taskStatusToColor(props.task.status_id)}
        active={props.active}
        minimal={props.minimal}
        onClick={props.onClick}
    >
        <div
            className={styles.wrapper}
            onClick={event => {
                event.preventDefault()
                event.stopPropagation()
            }}
        >
            <TenderPicker
                value={props.task.tender_id}
                disabled={props.task.status_id == TaskStatus.CLOSED || !canEdit}
                onChange={tender_id => dispatch(taskActions.update.request({
                    id: props.task.id,
                    tender_id,
                }))}
            />
        </div>
        <div className={styles.text}>
            <div className={Classes.noWrap}>{props.task.type.name}</div>
            {
                (isMobile && props.task.status_id !== TaskStatus.CLOSED) && <DeadlinePanel
                    value={props.task.deadline_at}
                    deadline_text={props.task.deadline}
                    deadline_type={props.task.deadline_type}
                />
            }
        </div>
        {props.children}
    </ColoredTab>
}

export default TaskTab